var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
export class PatientConsentStudyInformationViewModel extends PatientConsentViewModel {
    get primaryDiseaseOrConditions() {
        var _a;
        return (_a = this.patientConsentUIManager.primaryDiseaseOrConditions) !== null && _a !== void 0 ? _a : [];
    }
    get videoTranscode() {
        return this.patientConsentUIManager.videoTranscode;
    }
    get showVideo() {
        var _a, _b;
        return !!((_a = this.videoTranscode) === null || _a === void 0 ? void 0 : _a.hlsUrl) || !!((_b = this.videoTranscode) === null || _b === void 0 ? void 0 : _b.mp4Url);
    }
    get studyId() {
        return this.patientConsentUIManager.session.studyId;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentStudyInformationViewModel.prototype, "primaryDiseaseOrConditions", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentStudyInformationViewModel.prototype, "videoTranscode", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentStudyInformationViewModel.prototype, "showVideo", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentStudyInformationViewModel.prototype, "studyId", null);
